export { default as GroupSalesSlot } from './GroupSalesSlot';
